import {
  FORGOT_ADMIN_USER_PASSWORD,
  FORGOT_ADMIN_USER_PASSWORD_SUCCESS,
  FORGOT_ADMIN_USER_PASSWORD_ERROR,
  RESET_ADMIN_USER_PASSWORD,
  RESET_ADMIN_USER_PASSWORD_SUCCESS,
  RESET_ADMIN_USER_PASSWORD_ERROR,
  UPDATE_ADMIN_USER_PASSWORD,
  UPDATE_ADMIN_USER_PASSWORD_SUCCESS,
  UPDATE_ADMIN_USER_PASSWORD_ERROR,
} from "./actionTypes"

export const resetAdminUserPassword = (user, history) => {
  return {
    type: RESET_ADMIN_USER_PASSWORD,
    payload: { user, history },
  }
}

export const resetAdminUserPasswordSuccess = message => {
  return {
    type: RESET_ADMIN_USER_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const resetAdminUserPasswordError = message => {
  return {
    type: RESET_ADMIN_USER_PASSWORD_ERROR,
    payload: message,
  }
}

export const forgotAdminUserPassword = (user, history) => {
  return {
    type: FORGOT_ADMIN_USER_PASSWORD,
    payload: { user, history },
  }
}

export const forgotAdminUserPasswordSuccess = message => {
  return {
    type: FORGOT_ADMIN_USER_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const forgotAdminUserPasswordError = message => {
  return {
    type: FORGOT_ADMIN_USER_PASSWORD_ERROR,
    payload: message,
  }
}

export const updateAdminUserPassword = (user) => {
  return {
    type: UPDATE_ADMIN_USER_PASSWORD,
    payload: user,
  }
}

export const updateAdminUserPasswordSuccess = message => {
  return {
    type: UPDATE_ADMIN_USER_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const updateAdminUserPasswordError = message => {
  return {
    type: UPDATE_ADMIN_USER_PASSWORD_ERROR,
    payload: message,
  }
}
